export default __webpack_public_path__ + "static/media/cloud-computing.5aa4ad12.png";